import React, { Component } from 'react';
import Immutable from 'immutable';

// import Immutable from 'immutable';
import { withStyles } from '@material-ui/core/styles';
// import Box from '@material-ui/core/Box';
// import Typography from '@material-ui/core/Typography';
// import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import config from 'config/api'
// import Grid from '@material-ui/core/Grid';

// import withWidth from '@material-ui/core/withWidth';
import isArray from 'mout/lang/isArray';
// import IconPlay from '@material-ui/icons/PlayCircleFilled';
import Paper from '@material-ui/core/Paper';

// import AddIcon from '@material-ui/icons/Add';
// import EventIntro from 'components/Event/EventIntro';
import BlockTitle  from 'components/UI/BlockTitle';
// import BlockButton  from 'components/UI/BlockButton';
// import MyEventsContainer from 'components/Event/MyEventsContainer';
// import RemainingTime from 'components/UI/RemainingTime';

import Spinner from 'components/UI/Spinner';
import Header from '../Header/Header';
import Footer from '../Footer';
import LiveHelp from './LiveHelp';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
// import Bubble from 'components/UI/Bubble';
// import HelpSpeedTest from 'components/Help/HelpSpeedTest';
// import PopinWrapper from 'components/PopinWrapper';
// import EventSubscription from 'components/Event/EventSubscription';
// import EventSubscriptionFor from 'components/Event/EventSubscriptionFor';
import EventCardSimple from 'components/Event/EventCardSimple';
// import DialogPopinButton from 'components/UI/Dialog/DialogPopinButton';

import { Redirect } from 'react-router-dom'
import { withRouter } from 'react-router-dom'

import {
  fetchData,
  getDataHome,
  getLoadingError,
} from '../../ducks/asyncFetcher';

import {
  isLoggedIn,
  getCurrentUserRole,
getCurrentUser,
} from 'ducks/authentication';

import {primaryColor} from 'helpers/colors';

const AF_KEY = 'home';


const styles = (theme) => {
  // console.log(theme)
  return {
    mainWrapper: {
      marginTop: '-300px',
      position: 'relative',
      zIndex: 9,
      color: '#fff',
      fontSize: '14px',
      [theme.breakpoints.down('sm')]: {
        marginTop: '-270px'
      }
    },
    mainTitle: {
      // marginTop: 20,
      marginBottom: 40,
    },
    livePaper: {
      color: '#fff',
      maxWidth: 1024,
      margin: '0 auto',
      padding: '40px 20px 50px',
      [theme.breakpoints.down('sm')]: {
        margin: '0 20px'
      }
      // padding: '60px'
    },
    cardRoot: {
      padding: '50px 40px 30px',
      textAlign: 'left',
      maxWidth: 800,
      margin: '0 auto 30px',
      background: 'linear-gradient(278.43deg, #FFCCE7 0%, #30003B 100%)',
      position: 'relative',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center'
      }
    },
    cardImage: {
      position: 'absolute',
      top: 30,
      right: 30,
      borderRadius: 90,
      width: 130,
      height: 130,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: '50% 50%',
      border: '1px #ccc solid',
      [theme.breakpoints.down('sm')]: {
        position: 'relative',
        top: 'initial',
        right: 'initial',
        margin: '0 auto 40px'
      }
    },
    cartTitle: {
      fontSize: '33px'
    },
    cardContent: {
      width: '60%',
      margin: '40px 0',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      }
    },
    cardTimeRemaininTitle: {
      color: primaryColor,
      fontSize: '26px',
      marginBottom: 20
    },
    cardButton: {
      fontSize: '11px',
      padding: '15px 40px',
      backgroundColor: '#fff',
      margin: '0 auto 20px',
      display: 'flex',
      color: primaryColor,
      fontWeight: 'bold',
      letterSpacing: '0.92px',
      backgroundImage: 'none',
      '&:hover': {
        color: '#fff',
        backgroundColor: primaryColor,
        backgroundImage: 'none',
      }
    },
    cardTimeRemainin: {
      textAlign: 'center', margin: '0 auto 40px',
      [theme.breakpoints.down('sm')]: {
        marginBottom: 20
      }
    },
mainContent: {
height: 'calc(100% - 103px)'
}
  }
}
class Lives extends Component {
  constructor(props) {
    super(props);
    // this.state = {
    //   remainingTime: 0,
    //   remainingTimeDays: 0,
    //   remainingTimeHours: 0,
    //   remainingTimeMinutes: 0,
    //
    // }
    // this._runRemainingTimer = this._runRemainingTimer.bind(this);
    this._gotoLiveRoom = this._gotoLiveRoom.bind(this);
  }
  componentDidMount() {
    this.props.onMount();
    // this._startTimer();


  }
  // componentDidUpdate(oldProps) {
  //   if (oldProps.$$data === undefined && this.props.data !== undefined) {
  //     console.log('startIcon')
  //     this._startTimer();
  //   }
  //   // if (oldProps.$$data === undefined && this.props.$$data ) {
  //   //   if (this.props.location.hash !== '') {
  //   //     window.setTimeout(function() {
  //   //       const id = this.props.location.hash.replace('#', '');
  //   //       const el = document.getElementById(id);
  //   //       const top = el ? document.getElementById(id).offsetTop+10-document.getElementById('header').offsetHeight : false
  //   //       // console.log(id, el)
  //   //       window.scroll({
  //   //         top,
  //   //         // behavior: 'smooth'
  //   //       })
  //   //     }.bind(this), 50)
  //   //   }
  //   //
  //   // }
  // }
  // componentWillUnmount() {
  // }

  _gotoLiveRoom() {
    const $$card = this._getCard();
    // console.log('click', $$card.toJS())
    if ($$card !== undefined && $$card.get('eventLinkExternal') !== undefined && $$card.get('eventLinkExternal') !== null && $$card.get('eventLinkExternal') !== false) {
      // window.open($$card.get('eventLinkExternal'))
      const url = config.events+'/redir/'+$$card.get('id');
      console.log('redirecting to', url);
      window.open(url);
    }

  }
  _getCard() {
    const {$$data} = this.props;
    return $$data !== undefined && $$data.get('live') !== undefined && $$data.get('live').size > 0 ? $$data.get('live').get(0) : undefined
  }

  _getCardImage($$card) {
    let cardImage = false;
    // let cardPresentation = false;
    let decodedValues;
    if ($$card !== undefined && $$card.get('eventThumb') !== undefined && $$card.get('eventThumb') !== null && $$card.get('eventThumb') !== false) {
      try {
        decodedValues = JSON.parse($$card.get('eventThumb'));
      } catch (e) {}
      // console.log('decoded is', decodedValues)
      if (decodedValues !== undefined && isArray(decodedValues) && decodedValues[0] && decodedValues[0].dest) {
        cardImage = config.eventthumbpreview.replace('{eventId}', $$card.get('id'))+'/'+decodedValues[0].dest;
      }
    }
    return cardImage
  }

  render() {
    const { $$data, userRole, onPanelToggle, classes, $$user } = this.props;

    const $$subscriptions = userRole !== undefined && $$data !== undefined && $$data !== undefined ? $$data.get('myfutureevents').map(e => e.get('id')) : Immutable.Map();

    const $$card = this._getCard();

    // const cardImage = this._getCardImage($$card);

    // const {
    //   remainingTime,
    //   remainingTimeDays,
    //   remainingTimeHours,
    //   remainingTimeMinutes,
    // } = this.state;

    // console.log($$subscriptions.toJS())
    // if ($$data !== undefined)console.log('data is', $$data.toJS())
    return (<div className="home" style={{minHeight: '100%'}}>
    <div className={classes.mainContent}>
    <Header onPanelToggle={onPanelToggle} current="lives" headerContent={undefined} headerStyle={{minHeight: '500px', backgroundPosition: '50% 0'}}/>
    <ScrollToTopOnMount />
    <Choose>
      <When condition={$$data !== undefined && userRole === undefined}>
        <p>Go away...</p>
      </When>
      <When condition={$$data !== undefined && (userRole === 'member' || userRole === 'admin')}>
        <div className={classes.mainWrapper}>
          <Paper className={classes.livePaper} elevation={3}>
            <BlockTitle title={'Live'} className={classes.mainTitle} />
            <If condition={$$card !== undefined}>
            <EventCardSimple $$card={$$card} userRole={userRole} $$subscriptions={$$subscriptions} onSubscriptionComplete={this.props.onMount} $$user={$$user} showRemainingTime={true}/>
        </If>
      </Paper>
      <LiveHelp style={{marginBottom: 0}}/>
    </div>
  </When>
  <When condition={$$data !== undefined && (userRole === 'speaker')}>
    <p>No place for speaker</p>
  </When>
  <When condition={$$data !== undefined && (userRole === 'staff')}>
    return <Redirect to={{
        pathname: '/agenda',
        state: { from: this.props.location }
      }}/>
    </When>
    <Otherwise>
      <div className={'Loading'}>
        <Spinner style={{marginTop: 200}}>Chargement...</Spinner>
      </div>
    </Otherwise>
  </Choose>
</div>
  <Footer style={{zIndex: 189, marginTop: -10}}/>

  </div>);
}
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
    $$user: getCurrentUser(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {dispatch(fetchData( {key: AF_KEY, fetchUrl: config.home}))},
  };
}

// export default ;
export default withStyles(styles)(withRouter(connect(mapStateToProps, mapDispatchToProps)(Lives)));



// WEBPACK FOOTER //
// ./src/components/Lives/Lives.jsx